
<template>
    <svg t="1564192776791" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" >
        <path id='pa' d="M844.8 168.96c-81.92-76.8-189.44-112.64-322.56-112.64-133.12 0-250.88 46.08-337.92 133.12C97.28 281.6 51.2 394.24 51.2 527.36c0 133.12 40.96 235.52 128 317.44 81.92 81.92 194.56 122.88 332.8 122.88 87.04 0 158.72-10.24 220.16-30.72 20.48-5.12 30.72-25.6 30.72-46.08 0-15.36-5.12-30.72-20.48-35.84-10.24-10.24-30.72-10.24-40.96-5.12-51.2 15.36-112.64 25.6-184.32 25.6-112.64 0-199.68-30.72-261.12-97.28-66.56-66.56-97.28-148.48-97.28-256s35.84-199.68 102.4-271.36 153.6-107.52 261.12-107.52c107.52 0 189.44 30.72 250.88 87.04 61.44 56.32 92.16 133.12 92.16 230.4 0 61.44-10.24 117.76-35.84 153.6-20.48 35.84-51.2 56.32-81.92 56.32-10.24 0-51.2 0-51.2-92.16 0-5.12 5.12-92.16 20.48-266.24 0-15.36-5.12-25.6-10.24-35.84-10.24-10.24-20.48-15.36-35.84-15.36h-10.24c-20.48 0-40.96 15.36-46.08 35.84-5.12-5.12-15.36-15.36-25.6-20.48-20.48-10.24-46.08-20.48-76.8-20.48-71.68 0-128 30.72-174.08 87.04-46.08 56.32-66.56 128-66.56 209.92 0 66.56 15.36 117.76 51.2 153.6 30.72 40.96 76.8 61.44 128 61.44 66.56 0 117.76-30.72 148.48-92.16 15.36 61.44 61.44 92.16 128 92.16s122.88-30.72 168.96-87.04c51.2-56.32 76.8-133.12 76.8-220.16 0-117.76-40.96-220.16-128-291.84z m-245.76 281.6c0 66.56-10.24 122.88-35.84 163.84-25.6 40.96-56.32 56.32-92.16 56.32-25.6 0-46.08-10.24-61.44-30.72-15.36-20.48-25.6-51.2-25.6-87.04 0-56.32 15.36-107.52 40.96-148.48 25.6-35.84 56.32-56.32 97.28-56.32 51.2 5.12 76.8 35.84 76.8 102.4z" p-id="4350" :fill="color"></path>
    </svg>
</template>

<script>
import { create } from 'domain';
    export default {
        props:{
            size: {
                type: String,
                default: '120px'
            },
            color: {
                type: String,
                default: '#585858'
            }
        },
        created(){
            //7695.5078125
        }
    }
</script>

<style lang="less" scoped>
@keyframes around
{
    to {
        stroke-dashoffset: 0;
        fill: transparent;
    }
}
@keyframes fade
{
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    80% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}
#pa{
    //animation: fade 2s linear infinite;
}
path_bak{
    fill: transparent;  
    stroke: red ;
    stroke-dasharray: 0;
    stroke-dashoffset: 7696;
    stroke-width: 16px;
    animation: around 6s linear infinite;
}
</style>
